// import "babel-polyfill";
import Vue from 'vue'
import App from './App'
import router from './router'
import store from '@/store/store'
import instance from './http'
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import 'element-ui/lib/theme-chalk/display.css';
import * as echarts from 'echarts';
import Print from './plugins/print/Print'
import '../static/css/publicStyle.css'
import VDistpicker from 'v-distpicker'
import Fragment from 'vue-fragment'
import vueEsign from 'vue-esign'
import '../static/icons/iconfont.css'


Vue.use(vueEsign);
Vue.use(Fragment.Plugin)
Vue.component('v-distpicker', VDistpicker)
Vue.use(Print);
Vue.use(Element)


Vue.prototype.$echarts = echarts;
Vue.config.productionTip = false;
Vue.prototype.$axios = instance
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  data: () => {
    return {
      lifiFlag: true,
    }
  },
  // echarts,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js